// EmployeeContext.js
import React, {createContext, useContext, useEffect, useState} from "react";

const EmployeeContext = createContext();

export const EmployeeProvider = ({children, initialValue = false}) => {
  const [isEmployee, setIsEmployee] = useState(initialValue);
  const [isEmployeeLoaded, setIsEmployeeLoaded] = useState(false);

  // ذخیره در localStorage برای persistence بین refreshها
  useEffect(() => {
    const saved = localStorage.getItem("smart_login_is_employee");
    if (saved !== null) {
      setIsEmployee(saved === "true");
    }
    setIsEmployeeLoaded(true);
  }, []);

  useEffect(() => {
    if (isEmployeeLoaded) {
      localStorage.setItem("smart_login_is_employee", isEmployee.toString());
    }
  }, [isEmployee, isEmployeeLoaded]);

  const setEmployeeWithSync = (value) => {
    setIsEmployee(value);
    return value;
  };

  return (
    <EmployeeContext.Provider value={{
      isEmployee,
      setIsEmployee: setEmployeeWithSync,
      isEmployeeLoaded,
    }}>
      {children}
    </EmployeeContext.Provider>
  );
};

export const useEmployee = () => {
  const context = useContext(EmployeeContext);
  if (!context) {
    throw new Error("useEmployee must be used within EmployeeProvider");
  }
  return context;
};
